import { Protocol, RecordDraft } from '../../types/sharedTypeImpl.ts';
import { getWayOutOfSpecValues } from './wayOutOfSpec.ts';

/* Validate the record and alert the user if there are any issues */
export function validateRecordForm(record: RecordDraft, protocol: Protocol): boolean {
    const isMeasureInterval = record.measurementType === 'production';

    // Check if all actual values are valid numbers; fail otherwise
    for (const part of record.parts) {
        for (const [index, recordPos] of part.positionValues.entries()) {
            const position = protocol.positions[index];

            if (position.type !== 'measurement') continue;
            if (recordPos.value === '' || recordPos.value == null) continue;

            const numberValue = +(recordPos.value as string);
            if (numberValue < 0 || isNaN(numberValue)) {
                alert(`Actual value is invalid for position ${position.positionNumber}`);
                return false;
            }
        }
    }
    if (record.targetQuantity && isNaN(+record.targetQuantity)) {
        alert('Target quantity is not a valid number');
        return false;
    }
    if (record.partCount && isNaN(+record.partCount)) {
        alert('Part count is not a valid number');
        return false;
    }

    // Check if all required fields are filled; fail otherwise
    if (isMeasureInterval && record.partCount == null) {
        alert(`Part count must be set`);
        return false;
    }

    // Check if all expected fields are filled; ask for confirmation if not
    if (isMeasureInterval && !record.orderNumber) {
        const result = confirm(`Order number is not set. Continue anyway?`);
        if (!result) return false;
    }
    if (isMeasureInterval && !record.targetQuantity) {
        const result = confirm(`Target quantity is not set. Continue anyway?`);
        if (!result) return false;
    }

    // Check if all actual values are set; ask for confirmation if not
    const emptyPositions: string[] = [];
    const errors: string[] = [];
    const warnings: string[] = [];

    const comment = record.comment?.trim() ?? '';
    const wordsInComment = comment.split(/\s+/).filter((w) => w.length > 1); // ignore 1-letter "words"

    for (const part of record.parts) {
        for (const recordPos of part.positionValues) {
            const position = protocol.positions.find((p) => p.positionNumber === recordPos.positionNumber)!;

            // if (position.toolType === 'CMM' || position.toolType === 'VMM') {
            //     continue;
            // }
            if (recordPos.value == null || recordPos.value === '') {
                emptyPositions.push(position.positionNumber);
            }
        }
    }

    if (emptyPositions.length > 0) {
        if (wordsInComment.length < 2) {
            errors.push(
                `Comment must contain at least two meaningful words when some values are missing.\n` +
                    `Empty positions: ${emptyPositions.join(', ')}`,
            );
        } else {
            warnings.push(`Some position values are empty.\n` + `Empty positions: ${emptyPositions.join(', ')}`);
        }
    }

    // Find positions that are way out of spec
    for (const part of record.parts) {
        const wayOutOfSpecValues = getWayOutOfSpecValues(protocol, part.positionValues);
        for (const { position, recordPosition: positionValue } of wayOutOfSpecValues) {
            warnings.push(
                `Position ${position.positionNumber} is way out of spec ` +
                    `(value: ${positionValue.value}, nominal: ${position.nominal}). `
            );
        }
    }

    if (errors.length > 0) {
        alert(errors.join('\n\n') + (warnings.length > 0 ? '\n\nAlso, the following warnings were found:\n\n' + warnings.join('\n\n') : ''));
        return false;
    }

    if (warnings.length > 0) {
        const result = confirm('Please review the following warnings:\n\n' + warnings.join('\n\n') + '\n\nContinue anyway?');
        if (!result) return false;
    }

    return true;
}
